import React, { useMemo } from "react";
import "./Masonry.css";

// Put images in: public/gallery/
const FILES = [
  "gallery20.webp",
  "gallery21.webp",
  "gallery22.webp",
  "gallery23.webp",
  "gallery24.webp",
  "IMG_0955.webp",
  "gallery26.webp",
  "gallery27.webp",
  "gallery28.webp",
  "gallery29.webp",
  "gallery30.webp",
  "service7.webp",
  "gallery2.webp",
  "service2.webp",
  "service4.webp",
  "service5.webp",
];

const LABELS = {
  // "gallery20.webp": "Kitchen cleanout",
};

const MasonryGallery = () => {
  const items = useMemo(
    () =>
      FILES.map((name) => {
        // Absolute path from the public root:
        const src = `/${name}`;
        const alt =
          LABELS[name] ??
          name
            .replace(/\.(webp|jpg|jpeg|png|gif)$/i, "")
            .replace(/[-_]/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase());
        return { src, alt, name };
      }),
    []
  );

  // Function to format file names for display
  const formatFileName = (fileName) => {
    return fileName
      .replace(/\.(webp|jpg|jpeg|png|gif)$/i, "")
      .replace(/[-_]/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  return (
    <section className="masonry-gallery" aria-label="Project Gallery">
      <div className="gallery-header">
        <h2 className="gallery-title">Delivering Results You Can See</h2>
        <p className="gallery-subtitle">
          See how we transform spaces with our professional junk removal services
        </p>
      </div>

      {items.length === 0 ? (
        <div className="masonry-status">No media available yet.</div>
      ) : (
        <div className="masonry-grid">
          {items.map((item, idx) => (
            <div className="masonry-item" key={idx}>
              <div className="image-container">
                <img
                  src={item.src}
                  alt={item.alt}
                  className="gallery-image"
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.src =
                      "https://via.placeholder.com/640x360?text=Image+Unavailable";
                  }}
                />
                <div className="image-overlay">
                
               
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default MasonryGallery;